import React from 'react';
import Layout from './Layout';
import { motion } from 'framer-motion';
import image1 from '../assets/productsimages/Business Analysis.png';
import image2 from '../assets/portfolio/Free Business Analysis 1.png';
import image3 from '../assets/portfolio/Free Business Analysis Action Plan Picture.png';

// Animation configurations
const animations = {
  container: {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true },
    transition: { duration: 5, ease: "easeInOut" } // Shorter duration for a smoother fade-in
  },
  header: {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeOut" } // Faster and more natural easing
  },
  contentLeft: {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeInOut" } // Smooth slide-in effect
  },
  contentRight: {
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true },
    transition: { duration: 1.2, ease: "easeInOut" } // Smooth slide-in effect
  },
  image: (id) => ({
    initial: { opacity: 0, scale: 0.9 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true },
    transition: { duration: 1.5, delay: id * 0.2, ease: "easeOut" } // Subtle scaling with staggered delay
  }),
  button: {
    whileHover: { 
      scale: 1.1,
      backgroundColor: "#f3f4f6", // Slightly lighter hover effect
      transition: { duration: 0.3, ease: "easeInOut" } // Smooth hover transition
    }
  }
};

const BusinessAnalysis = () => {
  const sections = [
    {
      id: 1,
      title: "3 Pillars of business",
      text: "Every successful company relies on three core pillars, Sales & Marketing to drive revenue and market share by navigating complex landscapes and adhering to customer needs. Product Excellence, delivering a quality product or service to adhere to customer wants and needs. Lastly, Operations care aboout managing the people and ressources of the company while keeping it out of trouble. These pillars work in harmony where Sales secures market opportunities, Products delivers the service or product, and Operations ensures cost-effective execution.",
      image: image1,
      imageRight: true
    },
    {
      id: 2,
      title: "Risks Associated with the 3 Pillars",
      text: "Each pillar faces unique risks that require proactive management. Sales deal with market access barriers, customer negotiation challenges, and revenue declines. Product risks product misfit and being uncompetitive. Operations risks deal with key person risks, legal troubles and misalignment in the company. By understanding and mitigating these risks, I help ensure your business remains resilient and poised for long-term success in the competitive landscape.",
      image: image2,
      imageRight: false
    },
    {
      id: 3,
      title: "Connect with Me",
      text: 'If you are interested in having a pair of independent eyes take a look at your business, I initially will do so for free.\n\nTo discuss details, call +45 2936 4614, email Villingerbl@gmail.com, or invite me to a Teams meeting. I look forward to connecting.',
      image: image3,
      imageRight: true
    }
  ];

  return (
    <div>
      <Layout />
      <motion.div 
        {...animations.container}
        className="w-full min-h-screen bg-gradient-to-b from-white to-white text-black pt-20"
      >
        <div className="max-w-screen-lg mx-auto p-4">
          <motion.div 
            {...animations.header}
            className="mb-16 text-center"
          >
            <h1 className="text-4xl font-bold inline border-b-4 border-black">Free Business Analysis</h1>
            <p className="mt-6 text-lg max-w-2xl mx-auto">
              Complimentary assessment of operations, financial strategy, and growth potential for pharmaceutical companies.
            </p>
          </motion.div>
          
          <div className="space-y-20">
           {sections.map(({ id, title, text, image, imageRight }) => (
                         <motion.div 
                           key={id}
                           className={`flex flex-col md:flex-row items-center gap-8 ${
                             imageRight ? '' : 'md:flex-row-reverse'
                           }`}
                           initial={{ opacity: 0, y: 50 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           viewport={{ once: true }}
                           transition={{ duration: 1.2, delay: id * 0.5 }} // Staggered delay based on id
                         >
                           {/* Text Section */}
                           <motion.div
                             className="flex-1"
                           > 
                             <h2 className="text-2xl font-bold mb-4">{title}</h2>
                             <p className="text-lg whitespace-pre-wrap">{text}</p>
                             {id === 3 && (
                               <motion.button
                                 className="mt-6 px-5 py-2 bg-gray-100 rounded-md text-black font-medium"
                                 {...animations.button}
                                 onClick={() => window.location.href = "mailto:Villingerbl@gmail.com"}
                               >
                                 Contact Me
                               </motion.button>
                             )}
                           </motion.div>

                {/* Image Section */}
                <motion.div
                  className="flex-1"
                  {...animations.image(id)}
                >
                  <img 
                    src={image} 
                    alt={title} 
                    className="rounded-lg w-full h-auto shadow-md"
                  />
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessAnalysis;